// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBiaXIMayq2v8A9EY1BiVyo1FoeJt2AK0E",
    authDomain: "sahyadri-urban.firebaseapp.com",
    projectId: "sahyadri-urban",
    storageBucket: "sahyadri-urban.firebasestorage.app",
    messagingSenderId: "56441539274",
    appId: "1:56441539274:web:ce4ed0b595cfbf8d92c233",
    measurementId: "G-0GLNZ7ZMLX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;